module.exports = __webpack_public_path__ + "static/media/avatarProfile.e0f47229.svg";